<template>
  <div>
    <div class="container-fluid fullmetrics-contain">
          <div class="row">
            <div class="col-sm" ref="fullmetrics">
              <span class="float-end">
                <a v-if="this.checkFile == true" class="mr-4 btn btn-link" target="_blank" :href="`/user_report?report=${passedData}.csv.fullSociometrics.custom_printable.pdf`" :download="`${passedData}.csv.fullSociometrics.custom_printable.pdf`"><i class="fas fa-file-pdf"></i> Download Report as PDF</a>
                <button v-else class="mr-4 btn btn-link" @click="generateReport" v-bind:disabled="btnActive">
                  <div v-html="btnText"></div>
                </button>
                <a class="mr-4 btn btn-link" target="_blank" :href="`/user_dataset?dataset=appended-${passedData}.csv.FullSummaryResults.csv&format=raw&objid=null`"><i class="fas fa-file-csv"></i> Download as CSV</a>
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12" v-for="(data, index) in fullsociometric">
              <!-- start loop -->
              <div class="card mb-2 w-100">
                <div class="card-header">
                  <p class="lead">{{ index + 1 }}. {{ data.title }}</p>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-6">
                      {{ data.prose }}
                    </div>
                    <div class="col-3">
                      <BarChartTarget v-bind:targetData="data.target" />
                    </div>
                    <div class="col-3">
                      <BarChartBaseline v-bind:baseData="data.baseline" />
                    </div>
                  </div>
                </div>
              </div>
              <!-- end loop -->
            </div>
          </div>
          <div class="row d-none">
            <nav aria-label="Page navigation example">
              <ul class="pagination">
                <li class="page-item"><a class="page-link" @click="this.prev()">Previous</a></li>
                <!-- li class="page-item"><a 
                  class="page-link" 
                  v-for="item in Math.ceil(data.length / perPage)"
                  :key="item"
                  @click="() => goToPage(item)"
                >{{ item }}</a></li -->
                <li class="page-item"><a class="page-link" @click="this.next()">Next</a></li>
              </ul>
            </nav>
          </div>
        </div>
        <vue3-html2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="true"
            :preview-modal="true"
            :filename="this.sociometricfilename"
            :pdf-quality="1.5"
            :manual-pagination="true"
            pdf-content-width="800px"
            pdf-format="a4"
            pdf-orientation="portrait"
            @hasStartedGeneration="hasStartedGeneration()"
            @hasGenerated="hasGenerated($event)"
            ref="html2Pdf" 
        >
        <template  v-slot:pdf-content>
            <div slot="pdf-content" style="padding: 30px; margin: auto; font-size: 80%;">
            <div>
              <div>
                <h3>{{this.passedData}} Full Sociometric (pdf)</h3>
              </div>
            </div>
            <div>
            <!-- start loop -->
            <div v-for="(data, index) in fullsociometric" class="pdf-item w-85">
              <div class="card m-1">
                <div class="card-body">
                  <!-- start new -->
                  <div class="container-fluid">
                    <div class="row">
                      <div class="col-8">
                      <p><strong>{{ index + 1 }}. {{ data.title }}</strong></p>
                      <p style="line-height: 1.1rem"><small>{{ data.prose }}</small></p>
                      </div>
                      <div class="col-2 text-center">
                        <img :src="'/static/assets/src/img/charts/'+roundNumWhole(data.target)+'-donut.png'" class="img-fluid col-6" />
                        <p class="mb-0"><strong>{{roundNum(data.target)}}%</strong></p>
                        <p>Target</p>
                      </div>
                      <div class="col-2 text-center">
                        <img :src="'/static/assets/src/img/charts/'+roundNumWhole(data.baseline)+'-donut.png'" class="img-fluid col-6" />
                        <p class="mb-0"><strong>{{roundNum(data.baseline)}}%</strong></p>
                        <p>Baseline</p>
                      </div>
                    </div>
                  </div>
                  <!-- end new -->
                </div>
              </div>
              <div v-if="(index % 6 == 0) && index != 0 && index != 6 || index == 5">
                <div class="html2pdf__page-break"/>
                <div class="mb-2"></div>
              </div>
            </div>

            <!-- end loop -->
          </div>
        </div>
        </template>
        </vue3-html2pdf>
    </div>
</template>
<script>
import BarChartTarget from "./FullChartTarget.vue";
import BarChartBaseline from "./FullChartBaseline.vue";
import Vue3Html2pdf from 'vue3-html2pdf';
import axios from "axios";
import { onMounted, ref, defineAsyncComponent } from "vue";
export default {
  name: "Full Sociometric Tab",
  components: { BarChartTarget, BarChartBaseline, Vue3Html2pdf },
  props: {
    passedData: {
      type: String,
      default() {
        return "Dataset";
      },
    },
  },
  data() {
    return {
      fullsociometric: [],
      testDataElem: null,
      targetData: null,
      baseData: null,
      sociometricfilename: 'Full_Sociometric',
      btnActive: false,
      btnText: '<i class="fas fa-file-pdf"></i> Download as PDF',
      current: 1,
      pageSize: 10,
      checkFile: false
    };
  },
  mounted() {
    const reportName = this.passedData;
    this.sociometricfilename = this.passedData + '_Full_Sociometric';
    axios
      .get("/user_dataset", {
        params: {
          dataset: "appended-" + reportName + ".csv.serializedFullSummaryResults.json",
          format: "raw",
          objid: "",
        },
      })
      .then((response) => {
        this.fullsociometric = response.data;
        // console.log(JSON.stringify(this.fullsociometric));
        // const printable = reportName + ".csv.fullSociometrics.printable.pdf";
      })
      .catch(error => {
        this.errorMessage = error.message;
        console.error("There was an error!", error);
    });
    this.checkPDFExists();
  },
  methods: {
    roundNum(num) {
      return Math.round(num * 100) / 100
    },
    roundNumWhole(num) {
      return Math.round(num)
    },
    async checkPDFExists() {
      console.log('passed Data pre PDF check: '+this.passedData);
      let formData = new FormData();
      formData.append('filename', this.passedData);
      axios.post('/check_sociometric_pdf', formData)
      .then(
			(response) => {
          this.checkFile = JSON.parse(response.data);
          //console.log('check response PDF '+response.data);
          //if(response.data == 'true') {
            //this.checkFile = true;
          //} else {
            //this.checkFile = false;
          //};
          console.log('checkFile is '+this.checkFile);
      }).catch(error => {
        this.errorMessage = error.message;
        this.messageAlert({alert: 'There was an error!', classel: 'error'});
        console.error("There was an error!", error);
      });      
    },
    async generateReport () {
        this.btnText = '<i class="fas fa-spinner fa-spin-pulse"></i> Generating PDF...';
        this.btnActive = true;
        this.$refs.html2Pdf.generatePdf();
    },
    generateDonutPDF(num) {
      const newnum = 360*(num*0.01);
      return 'conic-gradient(#16325c 0deg '+newnum+'deg,#999999 '+newnum+'deg 360deg)';
    },
    prev() {
      this.current--;
    },
    next() {
      this.current++;
    },
    indexStart() {
      return (this.current - 1) * this.pageSize;
    },
    indexEnd() {
      return this.indexStart + this.pageSize;
    },
  }
};
</script>
